import { LpuOrder, LpuSession } from './types';
import { LPU_ORDERS, LPU_SESSIONS } from './lpuStubs';

export const USE_STUBS = true;

const delay = (ms = 200) => new Promise<void>(res => setTimeout(res, ms));

const stageAttempts: Record<number, number> = {};

export async function getLpuQueue(): Promise<LpuOrder[]> {
  if (USE_STUBS) {
    await delay();
    return LPU_ORDERS.filter(o => o.lifecycleStatus === 'picked');
  }
  throw new Error('Not implemented');
}

export async function getLpuStagedOrders(): Promise<LpuOrder[]> {
  if (USE_STUBS) {
    await delay();
    return LPU_ORDERS.filter(o => o.lifecycleStatus === 'lpu_staged');
  }
  throw new Error('Not implemented');
}

export async function getLpuOrder(id: number): Promise<LpuOrder | null> {
  if (USE_STUBS) {
    await delay();
    return LPU_ORDERS.find(o => o.shopifyOrderId === id) ?? null;
  }
  throw new Error('Not implemented');
}

export async function getOrCreateLpuSession(order: LpuOrder): Promise<LpuSession> {
  if (USE_STUBS) {
    await delay();
    if (LPU_SESSIONS[order.shopifyOrderId]) {
      return { ...LPU_SESSIONS[order.shopifyOrderId] };
    }
    return {
      orderId: order.shopifyOrderId,
      lineStates: Object.fromEntries(
        order.lines.map(l => [
          l.shopifyLineItemGid,
          { confirmed: false, exceptionType: null, exceptionReason: null },
        ]),
      ),
    };
  }
  throw new Error('Not implemented');
}

export async function stageOrder(orderId: number): Promise<{ success: boolean; error?: string }> {
  if (USE_STUBS) {
    await delay(900);
    stageAttempts[orderId] = (stageAttempts[orderId] ?? 0) + 1;
    // 9002 fails on first attempt (simulates Shopify timeout)
    if (orderId === 9002 && stageAttempts[orderId] === 1) {
      return { success: false, error: 'Shopify timeout — please retry.' };
    }
    return { success: true };
  }
  throw new Error('Not implemented');
}

export async function confirmPickup(
  _orderId: number,
): Promise<{ success: boolean; error?: string }> {
  if (USE_STUBS) {
    await delay(900);
    return { success: true };
  }
  throw new Error('Not implemented');
}
